module.exports = __webpack_public_path__ + "static/media/contract-icon.c5ef21d4.png";